// eslint-disable-next-line no-restricted-imports
import dayjs, { type Dayjs as DayjsType } from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import tz from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";

const dayjsExtended = dayjs;
dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(isBetween);
dayjs.extend(weekday);

export default dayjsExtended;

export const dayjsFactory = (locale: string | ILocale): DayjsConstructor => {
    return (date?: dayjs.ConfigType, format?: dayjs.OptionType): DayjsType =>
        dayjs(date, format).locale(locale);
};

export type DayjsConstructor = {
    (date?: dayjs.ConfigType, format?: dayjs.OptionType): DayjsType;
};

export type Dayjs = DayjsType;
